import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { didYouKnow } from '../extras/constants';
import rightIcon from '../../icons/rightChevronIcon.svg';
import { useNavigate } from 'react-router-dom';

const buyerProfileSectionList = [
  {
    id: 1,
    name: 'Edit Profile',
    action: '',
    screen: 'edit_profile',
    to: '/buyer/edit-profile',
  },
  {
    id: 2,
    name: 'Teams',
    action: '',
    screen: 'teams',
    to: '/buyer/edit-profile',
  },
  {
    id: 3,
    name: 'View Quotes',
    action: '',
    to: '/buyer/edit-profile',
  },
  {
    id: 4,
    name: 'View Purchase Order',
    action: '',
    to: '/buyer/edit-profile',
  },
];

const RightSidebar = ({ role, screen, setScreen }) => {
  const navigate = useNavigate();
  const { name, email, company_name } =
    useSelector((state) => state?.authReducer?.userData) || {};

  // State to hold a random fact
  const [randomFact, setRandomFact] = useState('');

  // Set a new random fact on initial render
  useEffect(() => {
    const getRandomFact = () => {
      const fact =
        didYouKnow[Math.floor(Math.random() * didYouKnow.length)].fact;
      setRandomFact(fact);
    };
    getRandomFact();
  }, []); // Empty dependency array means this runs only on the initial render

  const handleScreenChange = (changeTo) => {
    setScreen(changeTo);
  };

  const supplierFunction = () => {
    return (
      <div className="font-roboto pl-8 pr-7">
        <div className="flex my-4 items-center justify-start gap-5">
          <Avatar className="h-24 w-24">
            <AvatarFallback>
              {/* make it so that if a value is undefined it is not displayed */}
              {name.split(' ')[0][0] + name.split(' ')[1][0]}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold text-gray-700 mb-1">
              Hello, {name.split(' ')[0]}
            </h3>
            <p className="text-gray-500">{company_name}</p>
            <p className="text-gray-500">{email}</p>
          </div>
        </div>

        <div className="grid gap-3 grid-cols-4 justify-between my-8">
          <div className="production-this-month flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              65
            </span>
            <span className="text-sm text-gray-400">Production This Month</span>
          </div>
          <div className="projects-done flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              55
            </span>
            <span className="text-sm text-gray-400">Projects done</span>
          </div>
          <div className="in-progress flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              12
            </span>
            <span className="text-sm text-gray-400">In Progress</span>
          </div>
          <div className="overdue flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              2
            </span>
            <span className="text-sm text-gray-400">Overdue</span>
          </div>
        </div>

        <div className="did-you-know flex flex-col justify-start">
          <div className="text-lightPurple font-roboto font-semibold hover:text-darkPurple mb-1">
            Did you know?
          </div>
          <div className="text-sm text-gray-400">"{randomFact}"</div>
        </div>
      </div>
    );
  };

  const buyerFunction = () => {
    return (
      <div className="font-roboto pl-8 pr-7">
        <div className="flex my-4 items-center justify-start gap-5">
          <Avatar className="h-24 w-24">
            <AvatarFallback>
              {/* make it so that if a value is undefined it is not displayed */}
              {name.split(' ')[0][0] + name.split(' ')[1][0]}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold text-gray-700 mb-1">
              Hello, {name.split(' ')[0]}
            </h3>
            <p className="text-gray-500">{company_name}</p>
            <p className="text-gray-500">{email}</p>
          </div>
        </div>

        <div className="grid gap-3 grid-cols-4 justify-between my-8">
          <div className="production-this-month flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              65
            </span>
            <span className="text-sm text-gray-400">Production This Month</span>
          </div>
          <div className="projects-done flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              55
            </span>
            <span className="text-sm text-gray-400">Projects done</span>
          </div>
          <div className="in-progress flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              12
            </span>
            <span className="text-sm text-gray-400">In Progress</span>
          </div>
          <div className="overdue flex flex-col col-span-1">
            <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
              2
            </span>
            <span className="text-sm text-gray-400">Overdue</span>
          </div>
        </div>
        {/* profile settings section */}
        <div>
          {buyerProfileSectionList.map((item) => (
            <div key={item.id} onClick={() => navigate(item.to)}>
              <div className="mt-2 p-1 pl-2 flex flex-row justify-between items-center text-[#47586E] cursor-pointer font-medium">
                <span>{item.name}</span>
                <img className="h-6 w-6" src={rightIcon} alt="Icon" />
              </div>
              <hr className="border-t border-gray-300 opacity-30 " />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return <>{role === 'supplier' ? supplierFunction() : buyerFunction()}</>;
};

export default RightSidebar;
